import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MatSelectModule } from '@angular/material/select';
import { CreateTrayScreenEffects } from '../create-tray-screen/create-tray-screen.effects';
import { SharedModule } from '../shared/shared.module';
import { PageEditScreenComponent } from './components/page-edit-screen/page-edit-screen.component';
import { PageEditScreenRoutingComponent } from './page-edit-screen-routing.component';
import { PageEditScreenRoutingModule } from './page-edit-screen-routing.module';
import { PageEditScreenEffects } from './page-edit-screen.effects';
import { featureKey, reducer } from './page-edit-screen.reducer';
import { PageScreenModule } from '../page-screen/page-screen.module';
import { CONTENT_PAGE_DIALOG_SERVICE_TOKEN, REDEEM_PAGE_DIALOG_SERVICE_TOKEN } from './page-edit-screen.tokens';
import { ContentPageEditDialogService, RedeemPageEditDialogService } from './components/page-edit-screen/page-edit-dialog.service';
import { TrayAlertMessageComponent } from './components/tray-alert-message/tray-alert-message.component';

@NgModule({
  declarations: [PageEditScreenRoutingComponent, TrayAlertMessageComponent, PageEditScreenComponent],
  imports: [
    FormsModule,
    PageEditScreenRoutingModule,
    PageScreenModule,
    StoreModule.forFeature(featureKey, reducer),
    EffectsModule.forFeature([PageEditScreenEffects, CreateTrayScreenEffects]),
    SharedModule,
    MatSelectModule,
  ],
  providers: [
    {
      provide: CONTENT_PAGE_DIALOG_SERVICE_TOKEN,
      useClass: ContentPageEditDialogService,
    },
    {
      provide: REDEEM_PAGE_DIALOG_SERVICE_TOKEN,
      useClass: RedeemPageEditDialogService,
    },
  ],
})
export class PageEditScreenModule {}
